var compress = function (source_img_obj, imageType, quality) {

    var cvs = document.createElement('canvas');
    var width = source_img_obj.width;
    var height = source_img_obj.height;

    // calculate the width and height, constraining the proportions
    if (width > height) {
        if (width > 1024) {
            //height *= max_width / width;
            height = Math.round(height *= 1024 / width);
            width = 1024;
        }
    } else {
        if (height > 768) {
            //width *= max_height / height;
            width = Math.round(width *= 768 / height);
            height = 768;
        }
    }
    cvs.width = width;
    cvs.height = height;
    cvs.getContext("2d").drawImage(source_img_obj, 0, 0, width, height);
    return cvs.toDataURL(imageType, quality);
};

export default compress;


// WEBPACK FOOTER //
// ./src/App/Util/jic_compress.js